export default "__VITE_ASSET__1037cb8d__"